// extracted by mini-css-extract-plugin
export default {"message":"da4b604d459e0fce078b823e8772f203","message-position-absolute":"_27dfab6cdfc1ee3f2691c71a3abfbf2b","message-position-static":"d6d85d36bbcbfce111ee63910c85b20e"};